module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/bestConversionIcon.9c6c91da.svg";